export default __webpack_public_path__ + "static/media/lottery-wheel-bg-icdesign.a93daaba.png";